import { render } from "./RevenueByServicesChart.vue?vue&type=template&id=c4af1c76&scoped=true&ts=true"
import script from "./RevenueByServicesChart.vue?vue&type=script&lang=ts"
export * from "./RevenueByServicesChart.vue?vue&type=script&lang=ts"

import "./RevenueByServicesChart.vue?vue&type=style&index=0&id=c4af1c76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4af1c76"]])

export default __exports__